export * from './functions';
export var WarehousingType;
(function (WarehousingType) {
    WarehousingType[WarehousingType["Direct"] = 0] = "Direct";
    WarehousingType[WarehousingType["TransportTerminal"] = 1] = "TransportTerminal";
    WarehousingType[WarehousingType["Warehouse"] = 2] = "Warehouse";
    WarehousingType[WarehousingType["Warehouse24H"] = 3] = "Warehouse24H";
    WarehousingType[WarehousingType["OrderSelection"] = 4] = "OrderSelection";
    WarehousingType[WarehousingType["Frozen"] = 5] = "Frozen";
    WarehousingType[WarehousingType["Unknown"] = 6] = "Unknown";
})(WarehousingType || (WarehousingType = {}));
